import React, { useState, useEffect } from "react";
import axios from "axios";
import AWS from "aws-sdk";
import MultiSelect from "multiselect-react-dropdown";
import { toast } from "react-toastify";


const API_URL = process.env.REACT_APP_API_URL;

const AddProductForm = () => {
  const [formData, setFormData] = useState({
    title: "",
    briefDescription: "",
    description: "",
  featuredProduct: false, 
    images: [],
    brands: "",
    slug: "",
    attributes: {

    },
    category: [""],
    price: {
      min: "",
      max: "",
    },
    marketplaces: [
      { marketplaceId: "", price: "", url: "" },
    ],
  });

  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);
  const [marketplaces, setMarketplaces] = useState([]);
  const [attributes, setAttributes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [brandsResponse, marketplacesResponse, categoriesResponse] = await Promise.all([
          axios.get(`${API_URL}/company/getAllCompany`),
          axios.get(`${API_URL}/marketplace/getAllMarketplaces`),
          axios.get(`https://api.solarstation.in/productcategory/getAllproductcategories`),
        ]);

        setBrands(brandsResponse.data.data);
        setMarketplaces(marketplacesResponse.data);
        setCategories(categoriesResponse.data.data);
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      }
    };

    fetchDropdownData();
  }, []);

  useEffect(() => {
    if (formData.category) {
      const fetchAttributes = async () => {
        setLoading(true);
        try {
          const categoryName = categories.find(
            (category) => category._id === formData.category
          )?.name;

          if (categoryName) {
            const response = await axios.get(
              `https://api.solarstation.in/Attribute/getAllAttribute?categoryName=${encodeURIComponent(
                categoryName
              )}`
            );
            setAttributes(response.data.data);
          }
        } catch (error) {
          console.error("Error fetching attributes:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchAttributes();
    }
  }, [formData.category, categories]);

  const handleMultiSelectChange = (selectedList) => {
    const selectedMarketplaces = selectedList.map((item) => ({
      marketplaceId: item._id,
      name: item.name,
      price: "",
      url: "",
    }));

    setFormData((prev) => ({
      ...prev,
      marketplaces: selectedMarketplaces,
    }));
  };


  const handleInputChange = (e, index, field) => {
    const updatedMarketplaces = [...formData.marketplaces];
    updatedMarketplaces[index][field] = e.target.value;
    setFormData({ ...formData, marketplaces: updatedMarketplaces });
  };

  const handleChange = (e, field, index = null) => {
    const { name, value } = e.target;

    if (field === "images") {
      const updatedImages = [...formData.images];
      updatedImages[index] = value;
      setFormData({ ...formData, images: updatedImages });
    } else if (field === "attributes") {
      setFormData({
        ...formData,
        attributes: { ...formData.attributes, [name]: value },
      });
    } else if (field === "price") {
      setFormData({
        ...formData,
        price: { ...formData.price, [name]: value },
      });
    } else if (field === "marketplaces") {
      const updatedMarketplaces = [...formData.marketplaces];
      updatedMarketplaces[index] = { ...updatedMarketplaces[index], [name]: value };
      setFormData({ ...formData, marketplaces: updatedMarketplaces });
    } else if (field === "category") {
      const updatedCategories = [...formData.category];
      updatedCategories[index] = value;
      setFormData({ ...formData, category: updatedCategories });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleCategoryChange = (e) => {
    const selectedCategory = e.target.value;
    setFormData({ ...formData, category: selectedCategory, attributes: {} });
  };


  const handleImageUpload = async (file) => {
  if (!file) {
    toast.error("No file selected!");
    return null;
  }

  const formData = new FormData();
  formData.append("image", file);

  try {
    const response = await fetch(`${API_URL}/image/upload`, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Upload failed");
    }

    return data.imageUrl;
  } catch (error) {
    console.error("Upload Error:", error);
    toast.error("Error uploading image: " + error.message);
    return null;
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_URL}/products/add`, formData);
      alert("Product added successfully!");
    } catch (error) {
      console.error("Error adding product:", error);
      alert("Failed to add product. Please check the form data.");
    }
  };







  const handleFileChange = async (e) => {
  const files = Array.from(e.target.files);
  const uploadedUrls = [];

  for (const file of files) {
    const url = await handleImageUpload(file);
    if (url) uploadedUrls.push(url);
  }

  setFormData((prevData) => ({
    ...prevData,
    images: [...prevData.images, ...uploadedUrls],
  }));

  e.target.value = ""; // reset file input
};


  const handleRemoveImage = (index) => {
    const updatedImages = [...formData.images];
    updatedImages.splice(index, 1);
    setFormData({ ...formData, images: updatedImages });
  };


  return (
    <form onSubmit={handleSubmit} className="space-y-6 p-4 max-w-lg mx-auto">
      <h2 className="text-2xl font-bold">Add Product</h2>

      <input
        type="text"
        name="title"
        placeholder="Title"
        value={formData.title}
        onChange={handleChange}
        className="w-full border p-2 rounded"
        required
      />

      <input
        type="text"
        name="briefDescription"
        placeholder="Brief Description"
        value={formData.briefDescription}
        onChange={handleChange}
        className="w-full border p-2 rounded"
        required
      />

      <textarea
        name="description"
        placeholder="Description"
        value={formData.description}
        onChange={handleChange}
        className="w-full border p-2 rounded"
        required
      />
      <div className="space-y-2">
  <label>Is Featured</label>
  <input
    type="checkbox"
    name="featuredProduct"
    checked={formData.featuredProduct}
    onChange={(e) =>
      setFormData({ ...formData, featuredProduct: e.target.checked })
    }
    className="w-full border p-2 rounded"
  />
</div>

      <div className="space-y-2">
        <input
          type="number"
          name="min"
          value={formData.price.min}
          onChange={(e) => handleChange(e, "price")}
          placeholder="Min Price"
          className="w-full border p-2 rounded"
        />
        <input
          type="number"
          name="max"
          value={formData.price.max}
          onChange={(e) => handleChange(e, "price")}
          placeholder="Max Price"
          className="w-full border p-2 rounded"
        />
      </div>

      <div className="space-y-2">
        <input
          type="text"
          name="slug"
          value={formData.slug}
          onChange={handleChange}
          placeholder="Slug"
          className="w-full border p-2 rounded"
        />
      </div>

      <div>
        <input
          type="file"
          accept="image/*"
          multiple
          onChange={handleFileChange}
          className="w-full border p-2 rounded"
        />
        <p className="text-sm text-gray-500">You can select multiple images.</p>
      </div>

      <div className="space-y-4">
        {formData.images.length > 0 ? (
          formData.images.map((image, index) => (
            <div key={index} className="flex items-center space-x-4">
              <img
                src={image}
                alt={`Uploaded Image ${index + 1}`}
                className="w-20 h-20 object-cover"
              />
              <button
                type="button"
                onClick={() => handleRemoveImage(index)}
                className="bg-red-600 text-white py-1 px-3 rounded"
              >
                Remove
              </button>
            </div>
          ))
        ) : (
          <p>No images uploaded yet.</p>
        )}
      </div>


      <select
        name="brands"
        value={formData.brands}
        onChange={(e) => handleChange(e, "brands")}
        className="w-full border p-2 rounded"
        required
      >
        <option value="">Select Brand</option>
        {brands.map((brand) => (
          <option key={brand._id} value={brand._id}>
            {brand.title}
          </option>
        ))}
      </select>
      <h3 className="font-semibold">Select Marketplaces</h3>
      <MultiSelect
        options={marketplaces}
        selectedValues={formData.marketplaces.map((m) => ({
          _id: m.marketplaceId,
          name: m.name,
        }))}
        onSelect={handleMultiSelectChange}
        onRemove={handleMultiSelectChange}
        displayValue="name"
        className="w-full border p-2 rounded"
        placeholder="Select Marketplaces"
      />

      {formData.marketplaces.map((marketplace, index) => (
        <div key={marketplace.marketplaceId}>
          <h3 className="font-semibold">{marketplace.name}</h3>
          <input
            type="number"
            name="price"
            placeholder={`${marketplace.name} Price`}
            value={marketplace.price}
            onChange={(e) => handleInputChange(e, index, "price")}
            className="w-full border p-2 rounded"
          />
          <input
            type="url"
            name="url"
            placeholder={`${marketplace.name} URL`}
            value={marketplace.url}
            onChange={(e) => handleInputChange(e, index, "url")}
            className="w-full border p-2 rounded"
          />
        </div>
      ))}



      <select
        name="category"
        value={formData.category}
        onChange={handleCategoryChange}
        className="w-full border p-2 rounded"
        required
      >
        <option value="">Select Category</option>
        {categories.map((category) => (
          <option key={category._id} value={category._id}>
            {category.name}
          </option>
        ))}
      </select>

      {loading && <p>Loading attributes...</p>}
      {!loading && attributes.length > 0 && formData.category && (
        <div>
          <h3 className="text-lg font-semibold mt-6">Attributes</h3>
          {attributes.map((attribute) => (
            <div key={attribute._id} className="space-y-2">
              <label htmlFor={attribute.name}>{attribute.name}</label>
              <input
                type="text"
                name={attribute.name}
                id={attribute.name}
                value={formData.attributes[attribute.name] || ""}
                onChange={(e) => handleChange(e, "attributes")}
                placeholder={`Enter ${attribute.name}`}
                className="w-full border p-2 rounded"
              />
            </div>
          ))}
        </div>
      )}
      <button
        type="submit"
        className="w-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
      >
        Add Product
      </button>
    </form>
  );
};

export default AddProductForm;
